import logo from "./logo.svg";
import Allroutes from "./routes/Allroutes";
import "./App.css";
import { applySchoolColors } from "./helpers/applySchoolColors";
import { useEffect, useState } from "react";
import { School } from "lucide-react";
import SchoolNotFound from "./Components/common/SchoolNotfound";

function App() {
  const [isValidDomain, setIsValidDomain] = useState(null);

  useEffect(() => {
    applySchoolColors();

    const validateDomain = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_URL}/front/validate-domain`,
          // { credentials: "include" }
        );
        console.log("response validate domain", res);
        // console.log("mansi11111", res);
        const data = await res.json();
        console.log("data:-", data);

        //  console.log("mansi22222", data);

        if (!data.success) {
          setIsValidDomain(false);
          return;
        }

        if (data.success) {
          window.school = data.school; // optional global use
          setIsValidDomain(true);
        } else {
          setIsValidDomain(false);
        }
      } catch (err) {
        setIsValidDomain(false);
      }
    };

    validateDomain();
  }, []);

  return (
    <div className="App">
      {isValidDomain === null ? <></> : isValidDomain ? <Allroutes /> : <SchoolNotFound />}
    </div>
  );
}

export default App;
